import { Icon as LegacyIcon } from '@ant-design/compatible';
import { Button } from 'antd';
import React from 'react';

import AppContent from '@src/components/common/container/AppContent';
import withLocalize, { IWithLocalizeOwnProps } from '@src/components/common/localize/withLocalize';
import withRoles, { IWithRolesOwnProps } from '@src/components/common/role/withRoles';
import CourseListEditContainer from '@src/components/course/list/CourseListEditContainer';
import CourseListView from '@src/components/course/list/CourseListView';
import { ICourse } from '@src/model/course/Course';
import { ICourseGroup } from '@src/model/course/CourseGroup';
import { IUserInfo } from '@src/model/user/User';
import { UserRoleEnum } from '@src/model/user/UserRole';
import { ICollectionData } from '@src/service/business/common/types';
import { ICourseListFilter } from '@src/service/business/courses/courseListBusinessStore';
import AppConfigService from '@src/service/common/AppConfigService';

const MANUAL_PARTICIPATION_ENABLED = AppConfigService.getValue('courseManagement.manualParticipationEnabled');

interface IUserCourseListViewOwnProps {
  user: IUserInfo;
  courseGroups: ICourseGroup[];
  courseList: ICollectionData<ICourse>;
  courseListFilter: ICourseListFilter;
  sortValue: string[];
  onUpdateCourseList: () => void;
  onSortChange: (sort: string[]) => void;
  onPageChange: (page: number, size?: number) => void;
  onFilterChange: (filter: ICourseListFilter) => void;
}
type IUserCourseListViewProps = IUserCourseListViewOwnProps & IWithRolesOwnProps & IWithLocalizeOwnProps;

interface IUserCourseListViewState {
  isEditing: boolean;
}

class UserCourseListView extends React.Component<IUserCourseListViewProps, IUserCourseListViewState> {
  state: IUserCourseListViewState = {
    isEditing: false,
  };

  render = () => {
    const userIsActive = this.props.user && this.props.user.active;
    const userHasCourses = this.props.courseList && this.props.courseList.content.length;

    return (
      <React.Fragment>
        <AppContent
          title={
            this.props.allowedRoles([UserRoleEnum.ORGANIZATION_ADMIN]) &&
            MANUAL_PARTICIPATION_ENABLED &&
            userIsActive &&
            this.props.courseList && (
              <div className="text-right">
                <Button type="primary" onClick={this.toggleEdit}>
                  <LegacyIcon type={userHasCourses ? 'edit' : 'plus'} />
                  {this.props.translate(userHasCourses ? 'COURSE_LIST.EDIT_COURSES_LABEL' : 'COURSE_LIST.ADD_COURSES_LABEL')}
                </Button>
              </div>
            )
          }
        >
          <CourseListView
            courseList={this.props.courseList}
            getPath={this.getPath}
            courseGroups={this.props.courseGroups}
            courseListFilter={this.props.courseListFilter}
            sortValue={this.props.sortValue}
            showStatusBadge={false}
            showProgressView={true}
            onSortChange={this.props.onSortChange}
            onFilterChange={this.props.onFilterChange}
            onPageChange={this.props.onPageChange}
          />
        </AppContent>
        {this.state.isEditing && <CourseListEditContainer user={this.props.user} userCourseList={this.props.courseList.content} updateCourseList={this.props.onUpdateCourseList} onCancel={this.toggleEdit} />}
      </React.Fragment>
    );
  };
  private getPath = (id: string, lecture?: string) => {
    return `/course/${id}/${lecture}`;
  };
  private toggleEdit = () => {
    this.setState({ isEditing: !this.state.isEditing });
  };
}

export default withRoles(withLocalize<IUserCourseListViewOwnProps>(UserCourseListView as any));
